(function(){
  /* ---------- scroll reveal ---------- */
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); }
    });
  },{rootMargin:'0px 0px -10% 0px', threshold:0.12});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

  /* ---------- video poster click ---------- */
  const poster = document.getElementById('videoPoster');
  if(poster){
    poster.addEventListener('click', activateVideo);
    poster.addEventListener('keydown', e => { if(e.key==='Enter'||e.key===' '){ e.preventDefault(); activateVideo(); } });
  }
  function activateVideo(){
    const frame = document.getElementById('videoFrame');
    // Replace this iframe src with your video URL (YouTube/Vimeo/Wistia/self-hosted).
    // Example self-hosted: frame.innerHTML = '<video controls autoplay playsinline><source src="assets/video/shift-60s.mp4" type="video/mp4"></video>';
    frame.innerHTML = '<iframe src="about:blank" title="SHIFT 60-Second Explainer" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe>' +
      '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:#0a0612;color:#fff;font-family:JetBrains Mono,monospace;font-size:11px;letter-spacing:.28em;text-transform:uppercase;text-align:center;padding:24px;pointer-events:none">' +
      '<div>◆ Drop your video src here · YouTube · Vimeo · MP4<br/>(edit #videoFrame in the markup)</div>' +
      '</div>';
  }

  /* ---------- countdown (fake but visually anchored) ---------- */
  // Set founding window close date here. Default: 7 days from now in the visitor's browser.
  const target = new Date(Date.now() + (7*24*60*60*1000) + (14*60*60*1000) + (32*60*1000));
  function tick(){
    const now = Date.now();
    let diff = Math.max(0, target.getTime() - now);
    const d = Math.floor(diff / (24*3600*1000)); diff -= d*24*3600*1000;
    const h = Math.floor(diff / (3600*1000));    diff -= h*3600*1000;
    const m = Math.floor(diff / (60*1000));      diff -= m*60*1000;
    const s = Math.floor(diff / 1000);
    const pad = n => String(n).padStart(2,'0');
    const setN = (id,v) => { const el = document.getElementById(id); if(el) el.textContent = pad(v); };
    setN('cd-d', d); setN('cd-h', h); setN('cd-m', m); setN('cd-s', s);
  }
  tick(); setInterval(tick, 1000);

  /* ---------- tier picker / submitForm / pickTier (REMOVED 2026-05-26) ----------
     The join section now uses real Shopify cart forms (see shift-join.liquid).
     Each tier button is a <form action="/cart/add"> that POSTs to Shopify
     checkout — no client-side JS routing needed. Credit-card formatting +
     submitForm() + fake success-modal trigger all retired with the PCI form.
  */
  window.closeModal = function(){
    var modal = document.getElementById('successModal');
    if (modal) modal.classList.remove('show');
    document.body.style.overflow = '';
  };

  /* ---------- dead-code stub kept to satisfy legacy onclick="pickTier(N)" ---------- */
  window.pickTier = function(idx){
    const picks = document.querySelectorAll('.tpick');
    picks.forEach(p => p.classList.remove('active'));
    const target = document.querySelector('.tpick[data-tier="'+idx+'"]');
    if(target){
      target.classList.add('active');
      const amt = parseInt(target.dataset.amount, 10);
      const ci = document.getElementById('customAmount');
      if(ci) ci.value = '';
      updateSubmitAmount(amt);
    }
    // Smooth scroll to form on tier click from cards
    document.getElementById('join').scrollIntoView({behavior:'smooth', block:'start'});
  };

  function fmt(n){ return '$' + Number(n).toLocaleString('en-US'); }
  function updateSubmitAmount(n){
    const el = document.getElementById('submitAmount');
    if(el) el.textContent = fmt(n);
  }

  /* default selection */
  pickTierSilent(0);
  function pickTierSilent(idx){
    document.querySelectorAll('.tpick').forEach(p => p.classList.remove('active'));
    const t = document.querySelector('.tpick[data-tier="'+idx+'"]');
    if(t){ t.classList.add('active'); updateSubmitAmount(parseInt(t.dataset.amount,10)); }
  }

  /* custom amount overrides tier */
  const customAmount = document.getElementById('customAmount');
  if(customAmount){
    customAmount.addEventListener('input', e => {
      const v = parseInt(e.target.value, 10);
      if(!isNaN(v) && v >= 1000){
        document.querySelectorAll('.tpick').forEach(p => p.classList.remove('active'));
        updateSubmitAmount(v);
      }
    });
  }

  /* ---------- credit card formatting ---------- */
  const cn = document.getElementById('cardNumber');
  if(cn){
    cn.addEventListener('input', e => {
      let v = e.target.value.replace(/\D/g,'').slice(0,19);
      e.target.value = v.replace(/(.{4})/g,'$1 ').trim();
    });
  }
  const ce = document.getElementById('cardExp');
  if(ce){
    ce.addEventListener('input', e => {
      let v = e.target.value.replace(/\D/g,'').slice(0,4);
      if(v.length >= 3) v = v.slice(0,2) + ' / ' + v.slice(2);
      e.target.value = v;
    });
  }

  /* ---------- submit (REMOVED 2026-05-26) — see note above ---------- */

})();
